import { _t } from 'components/Utils/translation'
import { useEffect, useState } from 'react'
import styled from 'styled-components'

const GenderBarChart = ({
  data,
  title,
  question,
  user,
  userIsInGroup=false,

  sort,
  inverted = false,
}: {
  data: any
  title: string
  question: Question
  user?: string | number | undefined
  userIsInGroup?: boolean
  sort?: string[]
  color?: string
  inverted?: boolean
}) => {
  const [drawData, setDrawData] = useState<any>(null)
  const [maxValue, setMaxValue] = useState<number>(100)
  useEffect(() => {
    if (data) {
      var new_sorted: [string, number, string][] = []
      question.options?.map((m: any) => {
        var val = data[m.value] || 0
        new_sorted.push([m.value, val, m.label])
      })
      if (sort) {
        new_sorted = new_sorted.sort(
          (a, b) => sort.indexOf(a[0]) - sort.indexOf(b[0])
        )
      }
      const max = Math.max(...new_sorted.map((m) => m[1]))

      setMaxValue(max)
      setDrawData(new_sorted)
    }
  }, [data])

  if (!drawData) return null

  return (
    <GenderBarChartContainer>
      <ColWrapper>
        <Title>{title}</Title>
        <SingleBar
          inverted={inverted}
          max={maxValue}
          data={drawData as [string, number, string][]}
          user={user}
          userIsInGroup={userIsInGroup}
        />
      </ColWrapper>
    </GenderBarChartContainer>
  )
}

const SingleBar = ({
  data,
  user,
  userIsInGroup=false,
  max,
  inverted,
}: {
  data: [string, number, string][]
  user: string | number | undefined
  userIsInGroup?: boolean
  max: number
  inverted?: boolean
}) => {
  var sum = data.map((m) => m[1]).reduce((acc, curr) => acc + curr, 0)
  return (
    <Bar>
      <BarBackground>
        {data.map((g, i) => {
          return (
            <Row>
              <RowLabel>
                {g[2].charAt(0).toUpperCase() + g[2].slice(1)}
              </RowLabel>
              <BarComp
                height={16}
                isUser={user === g[0]}
                color={(user === g[0] &&userIsInGroup) ? '#00f0ff' : 'var(--purple-main)'}
                percent={(g[1] * 100) / max}
                value={
                  (+((g[1] * 100) / sum).toFixed(1)).toLocaleString() + '%'
                }
                inverted={inverted}
              />
            </Row>
          )
        })}
      </BarBackground>
    </Bar>
  )
}
const ColWrapper = styled.div`
  max-width: 668px;
  width: 668px;
  display: flex;
  margin-left: auto;
  margin-right: auto;
  flex-wrap: wrap;
  @media screen and (max-width: 711px) {
    max-width: calc(100vw - 40px);
    margin-left: unset;
    margin-right: unset;
  }
`
const BarComp = ({
  percent,
  height = 5,
  value,
  color = 'var(--blue-main)',
  isUser = false,
  inverted = false,
}: {
  percent: number
  height?: number
  value?: string
  color?: string
  isUser?: boolean
  inverted?: boolean
}) => {
  return (
    <BarCompBG $inverted={inverted}>
      <BarCompFill
        style={{
          backgroundColor: color,
          width: 'calc(' + percent + '% - 60px)',
          height: height + 'px',
          marginRight: value ? '10px' : undefined,
        }}
      />
      {isUser && <You $col={'#00f0ff'}>{_t('user') || 'uuu'}</You>}
      {value && <BarCompValue>{value}</BarCompValue>}
    </BarCompBG>
  )
}

const You = styled.div<{ $col: string }>`
  position: absolute;
  left: -75px;
  top: 50%;
  transform: translateY(-50%);
  background-color: ${(props) => props.$col};
  color: #fff;
  color: #202346;
  font-size: 15px;
  padding: 0px 15px;
  height: 30px;
  &:after {
    content: '';
    position: absolute;
    right: -14px;
    top: 50%;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-top: 15px solid transparent;
    border-bottom: 15px solid transparent;

    border-left: 15px solid ${(props) => props.$col};
  }
  @media screen and (max-width: 711px) {
    right: -40px;
    left: unset;
    padding: 0px 10px 0px 5px;
    &:after {
      content: '';
      position: absolute;
      left: -14px;
      top: 50%;
      transform: translateY(-50%);
      width: 0;
      height: 0;
      border: 0;
      border-top: 15px solid transparent;
      border-bottom: 15px solid transparent;

      border-right: 15px solid ${(props) => props.$col};
    }
  }
`
const BarCompBG = styled.div<{ $inverted: boolean }>`
  width: 100%;
  background-color: ${(props) =>
    props.$inverted ? 'var(--site-background)' : 'var(--section-bg)'};
  display: flex;
  align-items: center;
  position: relative;
`

const BarCompFill = styled.div`
  height: 12px;
  /*padding-left: 4px;*/
  background-color: #f00;
  /* border-bottom: 1px solid var(--site-background); */
  transition: all 0.3s ease-in-out;
`
const BarCompValue = styled.div`
  font-size: 12px;
  width: 50px;
  line-height: 1em;
  opacity: 0.5;
`

const GenderBarChartContainer = styled.div`
  /* border-top:  3px solid #202346; */
  width: 100%;
  margin-top: 60px;
  display: flex;
  position: relative;
  /* border-top: 4px solid var(--site-background); */
  flex-wrap: wrap;
  @media screen and (max-width: 711px) {
    max-width: calc(100vw - 60px);
    margin-left: unset;
    margin-right: unset;
    margin-top: 0px;
    padding: 20px;
    padding-right: 40px;
  }
`

const Row = styled.div`
  line-height: 1.5em;
  margin-bottom: 10px;
  /* display: flex; */
  /* border-bottom: 1px solid var(--site-background); */
  @media screen and (max-width: 711px) {
    margin-bottom: 5px;
  }
`

const RowLabel = styled.div`
  min-width: 50%;
  text-align: left;
  padding-right: 10px;
  font-size: 14px;
  position: relative;
  line-height: 1.8em;
  /* font-weight: 700; */
  @media screen and (max-width: 711px) {
    font-size: 13px;
  }
`
const Bar = styled.div`
  z-index: 10;
  margin-bottom: 4px;
  flex: 0 0 100%;
  padding: 0;
  line-height: 2em;
  @media screen and (max-width: 711px) {
    max-width: calc(100% - 20px);
  }
`

const Title = styled.div`
  z-index: 10;
  flex: 0 0 100%;
  text-align: left;
  font-size: 18px;
  line-height: 1.4em;
  letter-spacing: 0.3px;
  font-family: 'IBM Plex Sans', sans-serif;
  font-weight: 700;
  padding: 0;
  padding-top: 10px;
  margin-bottom: 15px;
  @media screen and (max-width: 711px) {
    font-size: 18px;
  }
`

const BarBackground = styled.div`
  /* display: flex; */
`

export default GenderBarChart
